var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',{staticClass:"mt-4 mb-0"},[_vm._v(_vm._s(_vm.t('consultants::page.title.consultants')))]),_vm._v(" "),_c('consultants-data-table',{attrs:{"list-route":_vm.listRoute,"initial-filters":_vm.initialFilters}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }